import { trackDesignerInteraction } from '@utils/gtm'
import router from 'next/router'
import {
  getInitialWidgetConfig,
  getResetCanvasColors,
} from '../../editor.utils'
import {
  useCurrentCanvasSide,
  useEditorConfig,
  useWidget,
} from '../../EditorDataProvider'

export function SettingsControl() {
  const { canvasConfig, updateCanvasConfig } = useCurrentCanvasSide()
  const editorConfig = useEditorConfig()
  const { widget, updateWidget } = useWidget(canvasConfig.activeWidgetType)

  return (
    <div
      className="m-4 text-xl text-center text-acai font-mori hover:cursor-pointer whitespace-nowrap"
      onClick={() => {
        const defaultWidget = getInitialWidgetConfig({ editorConfig })

        updateWidget({
          config: {
            ...defaultWidget?.config,
            assetSvgData: widget?.config?.assetSvgData,
          },
        })

        updateCanvasConfig({
          ...canvasConfig,

          ...getResetCanvasColors({
            enabledPickers:
              editorConfig?.productColorConfig?.map((picker) => picker.key) ||
              [],
            material: editorConfig?.material,
            productColorOption: editorConfig?.productColorOption,
          }),

          widgets: [
            {
              ...defaultWidget,
              config: {
                ...defaultWidget?.config,
                assetSvgData: widget?.config?.assetSvgData,
              },
            },
          ],
        })

        trackDesignerInteraction({
          event: 'designer-interaction',
          designerName: 'editor',
          componentName: `SettingsControl`,
          componentInformation: 'User reset online editor settings',
          selectedProductSlug: router.query?.slug.toString(),
          displayType: 'ButtonTilesSelector',
        })
      }}
    >
      Reset Design
    </div>
  )
}
